<template>
    <div>
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item :to="{ path: '/home' }">{{$t('home')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('wbddgl')}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="cont">
            <div class="listbox">
                <div class="listright" v-loading="loading">
                    <div class="search">
                        <div class="searchleft">
                            <el-form :inline="true" :model="searchform" class="demo-form-inline" @submit.native.prevent >
                                <el-form-item :label="$t('phone')">
                                    <el-input v-model="searchform.phone" @keyup.enter.native="onSubmit" size="small" :placeholder="$t('phone')">
                                    </el-input>
                                </el-form-item>
                                <el-form-item :label="$t('mchOrderNo')">
                                    <el-input v-model="searchform.loanId" @keyup.enter.native="onSubmit" size="small" :placeholder="$t('mchOrderNo')">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="clabe">
                                    <el-input v-model="searchform.clabe" @keyup.enter.native="onSubmit" size="small" placeholder="clabe">
                                    </el-input>
                                </el-form-item>
                                <el-form-item :label="$t('time')">
                                    <el-date-picker
                                    v-model="value1"
                                    type="datetimerange"
                                    size="small"
                                    range-separator="至"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    start-placeholder="开始时间"
                                    end-placeholder="结束时间">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item>
                                    <el-button size="small" type="primary" @click="onSubmit">{{$t('query')}}</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                    <el-table :data="list" :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                        <el-table-column prop="loanId" :label="$t('mchOrderNo')"></el-table-column>
                        <el-table-column prop="productName" :label="$t('cpm')"></el-table-column>
                        <el-table-column prop="name" :label="$t('name')"></el-table-column>
                        <el-table-column prop="phone" :label="$t('phone')"></el-table-column>
                        <el-table-column prop="email" :label="$t('email')"></el-table-column>
                        <el-table-column prop="amount" :label="$t('amount')"></el-table-column>
                        <el-table-column prop="plannedRepaymentAmount" :label="$t('plannedRepaymentAmount')"></el-table-column>
                        <el-table-column prop="overdueDays" :label="$t('overdueDays')"></el-table-column>
                        <el-table-column prop="channel" :label="$t('channel')"></el-table-column>
                        <el-table-column prop="calbe" label="calbe"></el-table-column>
                        <el-table-column prop="exclusiveLinks" :label="$t('exclusiveLinks')"></el-table-column>
                        <el-table-column prop="createTime" :label="$t('createTime')"></el-table-column>
                    </el-table>
                    <div class="page">
                        <app-page :total="total" :current="pageNo" :pageSize="pageSize"
                            @handleCurrentChange="currentchange" @handleSizeChange="handchange"></app-page>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>
<script>
    import apiurl from "@/api/public"
    import _api from "@/api/index"
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {
        LOAD_CHILDREN_OPTIONS
    } from '@riophae/vue-treeselect'
    export default {
        components: {
            Treeselect
        },
        data() {
            var rolesValid = (rule, value, callback) => {
                callback()
            }
            return {
                form: {
                    id: null,
                    loanId: null,
                    productName: null,
                    name: null,
                    createTime: null,
                    phone:null,
                    email:null,
                    amount:null,
                    plannedRepaymentAmount:null,
                    overdueDays:null,
                    channel:null,
                    calbe:null,
                    exclusiveLinks:null
                },
                searchform: {
                    phone: "",
                    loanId: ""
                },
                defaultProps: {
                    label: "name",
                    isLeaf: 'isLeaf'
                },
                loading: false,
                showadd: false,
                list: [],
                value1:[],
                searchform:{},
                total: 1,
                pageNo: 1,
                pageSize: 10,
                status: 1,
            }
        },
        created() {
            this.getList()
        },
        methods: {
            getList() {
                this.loading = true
                _api.get(apiurl.externalOrder, {
                    page: this.pageNo,
                    size: this.pageSize,
                    loanId: this.searchform.loanId,
                    phone: this.searchform.phone,
                    clabe: this.searchform.clabe,
                    createTime: this.value1
                }).then(res => {
                    this.loading = false
                    this.list = res.data.list
                    this.total = res.data.total
                })
            },
            onSubmit() {
                this.pageNo = 1
                this.getList()
            },
            handchange(data) { //分页Size变化
                this.pageSize = data
                this.pageNo = 1
                this.getList()
            },
            currentchange(data) { //当前页变化
                this.pageNo = data
                this.getList()
            },
        }
    }
</script>
<style scoped>
    .lefttop {
        padding: 8px;
    }

    .listbox {
        display: flex;
    }

    .listleft {
        width: 20%;
        border: 1px solid #EBEEF5;
    }

    .listright {
        width: 100%;
        margin-left: 1%;
    }

    .listrighttop {
        padding: 0 10px;
        background: rgb(245, 245, 245);
        height: 40px;
        overflow: hidden;
        line-height: 40px;
        border-bottom: 1px solid #EBEEF5;
    }

    .listrighttop strong {
        float: left;
    }

    .listrighttop span {
        float: right;
    }

    ::v-deep .vue-treeselect__control,
    ::v-deep .vue-treeselect__placeholder,
    ::v-deep .vue-treeselect__single-value {
        height: 30px;
        line-height: 30px;
    }
</style>